module.exports = __webpack_public_path__ + "img/Jenkins.91f756b.svg";